import React from 'react'
import styled from 'styled-components'

interface Props {
  label?: string
}

const Label = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`

const LabelLine = styled.div`
  width: 4px;
  height: 20px;
  border-radius: 99px;
  background: #2f3c5e;
`

const LabelName = styled.div`
  font-family: SUIT;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`

const LabelOnly = (props: Props) => {
  const { label } = props

  return (
    <Label>
      <LabelLine />
      <LabelName>{label || '라벨'}</LabelName>
    </Label>
  )
}

export default LabelOnly
